import util from '@bmp-vue/core/api/util'
const controller = 'Autocred'
export default Object.assign({}, util.GetCrud(controller, ['none']), {
})
